class Util {

    /**
     * @param {Object} target
     * @param {Object} varArgs
     * @returns {Object}
     */
    static merge(target, varArgs) {
        if (target === null) {
            throw new TypeError('target can not be null');
        }

        let to = Object(target);

        for (let index = 1; index < arguments.length; index++) {
            let nextSource = arguments[index];

            if (nextSource === null) {
                continue;
            }

            for (let nextKey in nextSource) {
                if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    continue;
                }

                to[nextKey] = nextSource[nextKey];
            }
        }

        return to;
    }
}